import { ReactElement } from 'react'
import { Props, Shape } from './styles'

const Skeleton = (props: Props): ReactElement => <Shape {...props} />

export default Skeleton
